import { IAppConfiguration } from './IAppConfiguration';

export default {
  tenantName : 'prodmls',
  aptorApi: 'https://prodmls.b2clogin.com/prodmls.onmicrosoft.com/B2C_1A_signup_signin',
  clientId: '39b74346-ea1e-471b-b35d-a81a8dfaee6b',
  redirectUrl:'https://ms.aptoronline.com',
  policyName: 'B2C_1A_signup_signin',
  inivtePolicy: 'B2C_1A_signup_invitation',
  forgotPasswordPolicy : 'B2C_1A_passwordreset',
  redirectLogoutUrl:'https://ms.aptoronline.com',
  enableImpersonation: true,
  knownAuthority: 'https://prodmls.b2clogin.com',
  mlsApiUrl:'https://ms-api.aptoronline.com/api/',
  ftpurl:"ms.aptoronline.com/",
  scopes: ['https://prodmls.onmicrosoft.com/a7eb27f0-1774-4661-b6b0-6a04e4005ef4/tasks.read']
} as IAppConfiguration;
